import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';

import { isLength, isRequired, sanitize, withMessage } from 'lib/utils/formValidation';
import ThemedFormInput from 'verify/components/ThemedFormInput';

const validate = {
  socialSecurityNumberLast4: [
    withMessage('Please enter the last 4 digits of your SSN', isRequired),
    withMessage('The SSN you entered is invalid', sanitize(/\D/g, isLength(4))),
  ],
};

interface ThemedFormSsnLast4InputProps {
  disabled?: boolean;
  name?: string;
}

export default (props: ThemedFormSsnLast4InputProps) => {
  const { disabled, name = 'social-security-number' } = props;

  const [t] = useTranslation();

  return (
    <Fragment>
      <Field
        name={name}
        component={ThemedFormInput}
        disabled={disabled}
        type='tel'
        maxLength={4}
        placeholder='####'
        label={t('form.identification-number.ssn-last-4')}
        validate={validate.socialSecurityNumberLast4}
      />
    </Fragment>
  );
};
